'use strict';
import {TaskType} from './TaskType';

export const PROJECT = TaskType.PROJECT;
export const PROJECT_SITE = TaskType.TEMPLATE;
export const SITE = TaskType.ASSET;

export const VALUES = [
  PROJECT,
  PROJECT_SITE,
  SITE,
];



// WEBPACK FOOTER //
// ./src/js/tasks/enums/TASK_TYPE.js